/**
 * SPARQL escaping for the app's own raw-query paths — the ONE place Festipod
 * escapes a value it splices into a SPARQL string.
 *
 * The SDK publishes no escaper: every SDK entry takes a value and validates it
 * at the door. But `docs.sparqlQuery` / `docs.sparqlUpdate` take a query STRING
 * the app builds itself (entityWrites, registration), so the app owns the
 * escaping of anything it interpolates into that string. Kept minimal and used
 * from both call sites rather than duplicated.
 */

/**
 * Escape a value landing inside a `"…"` SPARQL literal: backslash and quote
 * first (so the added escapes are not re-escaped), then the control characters
 * that would otherwise terminate the literal.
 */
export function escapeLiteral(value: string): string {
  return value
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')
    .replace(/\n/g, '\\n')
    .replace(/\r/g, '\\r')
    .replace(/\t/g, '\\t');
}

/**
 * Escape a value landing inside a `<…>` SPARQL IRIREF: percent-encode every
 * character an IRIREF may not contain (the delimiters, plus the C0 controls and
 * space). A well-formed document reference passes through unchanged.
 */
export function escapeIri(value: string): string {
  return value.replace(
    /[<>"{}|^`\\\u0000-\u0020]/g,
    c => `%${c.charCodeAt(0).toString(16).toUpperCase().padStart(2, '0')}`,
  );
}
